import { render } from "./NewDashboardNavbar.vue?vue&type=template&id=ae2fc932"
import script from "./NewDashboardNavbar.vue?vue&type=script&lang=js"
export * from "./NewDashboardNavbar.vue?vue&type=script&lang=js"

import "./NewDashboardNavbar.vue?vue&type=style&index=0&id=ae2fc932&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__